// reducers/sharedSafariReducer.js

export const initialSharedSafariState = {
    //shared sfari Listing
    sharedSafariData: [],
    summary: {},
    filters: {},
    //shared safari view
    safariViewData: null,
    safariViewLoading: true,
    safariViewError: '',
    intreastedUsersUrl: '',
    commentsUrl: '',
    intreastedUsers: [],
    totalIntreastedUsers: 0,
    instUserToggle: false,
    userComments: [],
    reportContentToggle: false,
    commentForFlag: null,
    //Oraganize Share Safari Fixed Departure
    toggleOragnize: false,
    noOfStep: 6,
    step: 1,
    organizeSafari: {
        share_safari_title: '',
        park_id: '',
        start_date: '',
        end_date: '',
        no_of_safari: '',
    },
    organizeSafariErrors: {
        share_safari_title: '',
        park_id: '',
        start_date: '',
        end_date: '',
        no_of_safari: '',
    }

};

export const sharedSafariReducer = (state = initialSharedSafariState, action) => {
    switch (action.type) {
        //shared sfari Listing
        case 'SET_SHARED_SAFARI_DATA':
            return {
                ...state,
                sharedSafariData: Array.isArray(action.payload)
                    ? action.payload
                    : state.sharedSafariData,
            };

        case 'APPEND_SHARED_SAFARI_DATA':
            return {
                ...state,
                sharedSafariData: [
                    ...state.sharedSafariData,
                    ...action.payload.filter(
                        newItem => !state.sharedSafariData.some(existing => existing.slug === newItem.slug)
                    ),
                ],
            };

        case 'SHARED_SAFARI_SUMMARY':
            return {
                ...state,
                summary: action.payload && typeof action.payload === 'object'
                    ? action.payload
                    : state.summary,
            };

        case 'SET_SHARED_SAFARI_FILTERS':
            return {
                ...state,
                filters: action.payload && typeof action.payload === 'object'
                    ? action.payload
                    : state.filters,
            };

        case 'UPDATE_SHARED_SAFARI_FILTER':
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...(action.payload && typeof action.payload === 'object' ? action.payload : {}),
                },
            };
        //shared safari view
        case "SET_SHARED_SAFARI_VIEW_LOADING":
            return {
                ...state,
                safariViewLoading: typeof action.payload === "boolean" ? action.payload : state.safariViewLoading,
            };
        case 'SET_SHARED_SAFARI_VIEW_DETAILS':
            return {
                ...state,
                safariViewData: action.payload && typeof action.payload === 'object'
                    ? action.payload
                    : state.safariViewData,
            };
        case 'UPDATE_SHARED_SAFARI_VIEW_DETAILS':
            return {
                ...state,
                safariViewData: {
                    ...state.safariViewData,
                    ...(action.payload && typeof action.payload === 'object' ? action.payload : {}),
                },
            };

        case "SET_SHARED_SAFARI_VIEW_ERROR":
            return {
                ...state,
                safariViewError: typeof action.payload === "boolean" ? action.payload : state.safariViewError,
            };
        case "SET_SHARED_SAFARI_VIEW_INTRESTED_USER_URL":
            return {
                ...state,
                intreastedUsersUrl: typeof action.payload === 'string' && action.payload.trim().length > 0 ? action.payload : state.intreastedUsers,
            };

        case "SET_SHARED_SAFARI_VIEW_INTRESTED_COMMENTS_URL":
            return {
                ...state,
                commentsUrl: typeof action.payload === 'string' && action.payload.trim().length > 0 ? action.payload : state.comments,
            };
        case "SET_SHARED_SAFARI_VIEW_INTRESTED_USERS":
            return {
                ...state,
                intreastedUsers: Array.isArray(action.payload?.users)
                    ? action.payload.users
                    : state.intreastedUsers,
                totalIntreastedUsers: typeof action.payload?.total === "number"
                    ? action.payload.total
                    : state.totalIntreastedUsers,
            };

        case "SET_SHARED_SAFARI_VIEW_USERS_COMMENTS":
            return {
                ...state,
                userComments: Array.isArray(action.payload) ? action.payload : state.userComments,
            };
        case "SET_SHARED_SAFARI_VIEW_USERS_TOGGLE":
            return {
                ...state,
                instUserToggle: typeof action.payload === "boolean" ? action.payload : state.instUserToggle,
            };
        case "SET_SHARED_SAFARI_REPORT_CONTENT_TOGGLE":
            return {
                ...state,
                reportContentToggle: typeof action.payload === "boolean" ? action.payload : state.reportContentToggle,
            };
        case "SET_SHARED_COMMENT_FOR_FLAG":

            return {
                ...state,
                commentForFlag: action.payload && typeof action.payload === 'object'
                    ? action.payload
                    : state.commentForFlag,
            };
        //Organize Share Safari
        case "ORGANIZE_SHARE_SAFARI_TOGGLE":
            return {
                ...state,
                toggleOragnize: typeof action.payload === "boolean" ? action.payload : state.toggleOragnize,
            };
        case "ORGANIZE_SF_SET_STEP":
            return {
                ...state,
                step: typeof action.payload?.total === "number" ? action.payload : state.step,
            };
        case "UPDATE_ORGANIZE_SHARE_SAFARI":
            return {
                ...state,
                organizeSafari: {
                    ...state.organizeSafari,
                    ...action.payload,
                },
            };
        case "SET_ERRORS_ORGANIZE_SHARE_SAFARI":
            return {
                ...state,
                organizeSafariErrors: {
                    ...state.organizeSafariErrors,
                    ...action.payload,
                },
            };


        default:
            return state;
    }
};
